import wixLocation from 'wix-location';
import wixStores from 'wix-stores'

$w.onReady(function () {
    if (wixLocation.path && wixLocation.path[0] === "checkout") {
        setTimeout(() => {
            if (wixLocation.path[0] === "checkout") {
                //only if still in checkout
                //TODO: clear delivery data to force the user to choose new one
                //redirect to cart or any other page
                console.log("redirect to cart")
                wixLocation.to('/cart')
            }
        }, 3600000); //set for on hour
    }
})